/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EducationProgramImageReference } from '../../models/education-program-image-reference';

export interface CreateEducationProgramImageReference$Params {
  educationProgramId: string;
      body?: EducationProgramImageReference
}

export function createEducationProgramImageReference(http: HttpClient, rootUrl: string, params: CreateEducationProgramImageReference$Params, context?: HttpContext): Observable<StrictHttpResponse<EducationProgramImageReference>> {
  const rb = new RequestBuilder(rootUrl, createEducationProgramImageReference.PATH, 'post');
  if (params) {
    rb.path('educationProgramId', params.educationProgramId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EducationProgramImageReference>;
    })
  );
}

createEducationProgramImageReference.PATH = '/educationprogram/{educationProgramId}/images';
